import { AppBaseProps, CommonApp, Entity } from "../core/components/commonApp";
import { Grid } from "../core/components/grid";
import { AppHelper } from "../appHelper";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Config } from "../core/config/config";
import { DialogHelper } from "../core/util/dialogHelper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { EntityWeeklyReport, WeeklyReportInGrid } from "./weeklyReportInGrid";
import { SheetEventType } from "../../siteManagement/sheet";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
export class WeeklyReportApp extends React.Component<WeeklyReportAppProps, {
    showPleaseSaveMessage?: boolean;
}> {
    common = new AppHelper();
    weeklySummaryGridOptions = {};
    weeklyReportInGridOptions = {};
    inGridRef: WeeklyReportInGrid;
    translations = {};
    lockId = null;
    //schaltet den Browsertab-Titel an; wird von common aufgerufen
    setTabTitle = true;

    constructor(props: WeeklyReportAppProps) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.common.addInGridValidation([
            { gridOptions: this.weeklyReportInGridOptions, model: "entity.Entries", gridName: Helper.getTranslation("WebSMS.ServiceReport.Zeiten") }
        ]);
        this.state = {
            showPleaseSaveMessage: false
        }
        var that = this;
        if (props.entity.RecordRight.CanWrite) {
            this.common.unloadHelper.addBeforeUnloadCallback(function () {
                that.releaseLock();
            });
        }
        this.setLock();
    }


    componentDidMount() {
        this.props.entity.SaveTimeShift = Config.user.saveTimeShift;
    }

    private calcZeit(zeit: number): number {
        return Helper.isNumber(zeit) ? zeit : 0;
    }

    private _createWeeklySummary = (data: Array<EntityWeeklyReportEntry>): Array<WeeklyReportSummaryGridItem> => {
        const result: Array<WeeklyReportSummaryGridItem> = [];
        const hash: StringKeyDictionary<WeeklyReportSummaryGridItem> = {};


        if (Array.isArray(data)) {
            for (let i = 0; i < data.length; i++) {
                const item = data[i];

                if (this.calcZeit(item.Zarbeit) < 0 || this.calcZeit(item.Zfahrt) < 0 || this.calcZeit(item.Zpause) < 0)
                    return null;

                if (!hash[kendo.toString(item.Datum, "d")]) {
                    hash[kendo.toString(item.Datum, "d")] = {
                        DateAsString: kendo.toString(item.Datum, "d"),
                        Date: item.Datum,
                        WorkMinutes: this.calcZeit(item.Zarbeit),
                        WorkMinutesAsString: "00:00",
                        TravelMinutes: this.calcZeit(item.Zfahrt),
                        TravelMinutesAsString: "00:00",
                        BreakMinutes: this.calcZeit(item.Zpause),
                        BreakMinutesAsString: "00:00",
                        TotalDailyMinutes: 0,
                        TotalDailyMinutesAsString: "00:00",
                        IsLowerAsStandard: true
                    }
                } else {


                    hash[kendo.toString(item.Datum, "d")].WorkMinutes += this.calcZeit(item.Zarbeit);
                    hash[kendo.toString(item.Datum, "d")].TravelMinutes += this.calcZeit(item.Zfahrt);
                    hash[kendo.toString(item.Datum, "d")].BreakMinutes += this.calcZeit(item.Zpause);
                }
            }

            for (let d in hash) {
                hash[d].TotalDailyMinutes = hash[d].WorkMinutes + hash[d].TravelMinutes;// + hash[d].BreakMinutes;
                hash[d].WorkMinutesAsString = Helper.dates.fromMinutesSinceMidnight(hash[d].WorkMinutes);
                hash[d].TravelMinutesAsString = Helper.dates.fromMinutesSinceMidnight(hash[d].TravelMinutes);
                hash[d].BreakMinutesAsString = Helper.dates.fromMinutesSinceMidnight(hash[d].BreakMinutes);
                hash[d].TotalDailyMinutesAsString = Helper.dates.fromMinutesSinceMidnight(hash[d].TotalDailyMinutes);

                if (hash[d].TotalDailyMinutes >= this.props.stdMinuten) {
                    hash[d].IsLowerAsStandard = false;
                }


                const date = Helper.dates.toDate(hash[d].Date);

                if (Helper.hasValue(this.props.dayOfWeekSaturdayRessource) && date.getDay() === this.props.dayOfWeekSaturdayRessource)
                    hash[d].IsLowerAsStandard = false;

                if (Helper.hasValue(this.props.dayOfWeekSundayRessource) && date.getDay() === this.props.dayOfWeekSundayRessource)
                    hash[d].IsLowerAsStandard = false;

                result.push(hash[d]);
            }

            result.sort((a, b) => {
                if (a.Date < b.Date) {
                    return -1;
                } else if (a.Date > b.Date) {
                    return 1;
                } else {
                    return 0;
                }
            })
        }

        return result;
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    // Nicht ausgefüllte Tage rot markieren
    handleDataBound = (e) => {
        var data = e.sender.dataSource.data();
        for (var i = 0; i < data.length; i++) {
            if (data[i].IsDummyEntry) {
                var row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                var cell = $("td:first", row);
                cell.css("background-color", "red");
                cell.css("color", "white");
            }
        }
    }

    onChange = () => {
        this.common.setEntityDirtyState(true);
        this.setState({ showPleaseSaveMessage: true });
    }

    createInGrid = (defaultFieldProps: any) => {
        return <WeeklyReportInGrid entity={this.props.entity} data={this.props.entity.Entries}
                                   gridOptions={this.weeklyReportInGridOptions} dataSources={this.props.dataSources}
                                   translations={this.translations} ref={(ref) => this.inGridRef = ref}
                                   onChange={this.onChange} helpEditUrl={defaultFieldProps.helpUrl} id={""} />;
    }

    private _getLabelText(text: string): any {
        const labelStyle: React.CSSProperties = {
            marginBottom: "20px",
            marginTop: "20px",
            fontWeight: "bold",
            fontSize: "20px",
            display: "block",
            color: "red",
            marginLeft: "20px"
        };

        const labelText = text;
        return (<div style={{ marginTop: "20px" }}> <label className="" style={labelStyle}>{labelText}</label></div>);

    }

    createGridSummary = () => {
        let weeklySummary: Array<WeeklyReportSummaryGridItem> = [];

        let notification = null;
        if (this.state.showPleaseSaveMessage) {
            notification = this._getLabelText(this.translations["WebSMS.WeeklyReport.PleaseSaveMessage"]);
            return (<div>
                {notification}
                <Grid data={weeklySummary} options={this.weeklySummaryGridOptions} id="weeklyReportSummary" />
            </div>
            );
        }
        else {
            const temp = this._createWeeklySummary(this.props.entity.Entries);

            if (temp == null) {
                notification = this._getLabelText(this.translations["WebSMS.WeeklyReport.DataNotValid"]);
                return (
                    <div>
                        {notification}
                        <Grid data={weeklySummary} options={this.weeklySummaryGridOptions} id="weeklyReportSummary" />
                    </div>);
            }

            return (<Grid data={temp} options={this.weeklySummaryGridOptions} id="weeklyReportSummary" />);
        }
    }

    save = (closeAfterSave) => {
        this.props.entity.Entries = this.inGridRef.getEntries();
        if (this.props.entity.isConverted) {
            DialogHelper.confirm(this.translations["WebSMS.WeeklyReport.KonertiertSpeichern"]).then(isOK => {
                if (isOK) {
                    if (this.common.validate()) {
                        HTTPService.post("WeeklyReport/Save", this.props.entity)
                            .then(result => {
                                if (result.Code === 0) {
                                    this.reloadData();
                                    NotificationHelper.showSuccessMessage(result.Message);
                                    this.props.entity.isConverted = false;
                                    this.common.updateBrowserTitle();
                                } else if (result.Code > 0) {
                                    NotificationHelper.showErrorMessage(result.Message);
                                }

                                this.common.handlePostSave(result.Code === 0, closeAfterSave);
                            });
                    }
                }
            }
            );
        } else
            if (this.common.validate()) {
                HTTPService.post("WeeklyReport/Save", this.props.entity)
                    .then(result => {
                        if (result.Code === 0) {
                            this.reloadData();
                            NotificationHelper.showSuccessMessage(result.Message);
                        } else if (result.Code > 0) {
                            NotificationHelper.showErrorMessage(result.Message);
                        }

                        this.common.handlePostSave(result.Code === 0, closeAfterSave);
                    });
            }
    }

    deleteWeeklyReport = async () => {
        let isOk = await DialogHelper.confirm(Config.translations.deleteMessage);
        if (isOk) {
            let result = await HTTPService.post<JsonResultClass>("WeeklyReport/Delete/?belegNr=" + encodeURIComponent(this.props.entity.Belegnr));
            if (result.Code == 0) {
                NotificationHelper.showSuccessMessage(this.translations["Ressource.LöschenErfolgreich"]);
                this.closeWindow();
            }
            else
                NotificationHelper.showErrorMessage(result.Message);
        };
    }

    reloadData = () => {
        HTTPService.get<JsonResultClass>("WeeklyReport/Init/?id=" + encodeURIComponent(this.props.entity.Belegnr))
            .then(result => {
                if (result.Code > 0) {
                    NotificationHelper.showErrorMessage(result.Message);
                }
                else {
                    Helper.updateEntity(this.props.entity, result.Data);
                    this.setLock();
                    this.setState({ showPleaseSaveMessage: false });
                }
            });
    }

    setLock = () => {
        if (this.lockId === null && this.props.entity.RecordRight.CanWrite && !this.props.entity.IsNew) {
            this.lockId = Helper.keepLockAlive("Lock.ashx", this.props.entity.Belegnr, "LBKOPF", 10000);
        }
    }

    releaseLock = () => {
        if (this.lockId !== null) {
            clearInterval(this.lockId);
            Helper.releaseLock(this.props.entity.Belegnr, "LBKOPF");
            this.lockId = null;
        }
    }

    closeWindow = () => {
        if (this.common.isWindow) {
            this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
            this.common.sheetWrapper.hide();
        } else {
            this.props.entity.RecordRight.CanWrite = false;
            this.setState({});
            setTimeout(() => {
                window.location.href = Config.baseUrl + "DynamicSearch/weeklyreport";
            }, 1000);
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
};

interface WeeklyReportSummaryGridItem {
    Date: Date;
    DateAsString: string;
    WorkMinutes: number;
    WorkMinutesAsString: string;
    TravelMinutes: number;
    TravelMinutesAsString: string;
    BreakMinutes: number;
    BreakMinutesAsString: string;
    TotalDailyMinutes: number;
    TotalDailyMinutesAsString: string;
    IsLowerAsStandard: boolean;
}

export interface WeeklyReportAppProps extends AppBaseProps {
    entity: EntityWeeklyReport;
    stdMinuten: number;
    firstDayOfWeek: number;
    dayOfWeekSaturdayRessource: number;
    dayOfWeekSundayRessource: number;
}

export interface EntityWeeklyReportEntry extends Entity {
    Pos?: number;
    Datum?: Date;
    Tag?: string;
    Zvon?: number;
    Zbis?: number;
    Zarbeit?: number;
    Zfahrt?: number;
    Zpause?: number;
    Zgesamt?: number;
    Timetypeisguid?: string;
    Utcoffset?: number;
    UtcoffsetZBis?: number;
    Bemerkung?: string;
    Belegnr: number;
    Projnr: string;
    Ressnr: string;
    IsProduktiveTaetigkeit?: boolean;
    TaetigkeitId?: number;
    Kunde_Taetigkeit?: string;
    Isguid: string;
    Changed: boolean;
    Zeittyp?: number;
    DatumUtc?: string;
    TotalTime?: number;
}